import 'core-js/stable/promise'; // We have to import the promise polyfill as Webpack's import() relies on it
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import store from 'src/redux/store';
import GlobalStyle from 'components/_utility/GlobalStyle/GlobalStyle';
import App from './App';
import theme from './lib/theme';
import 'core-js/stable/object';

const render = () => {
  const rootEl = document.getElementById('configurator-root');
  const contentApiEndpoint = rootEl.dataset.apiEntrypoint;
  const { basepath } = rootEl.dataset;

  ReactDOM.render(
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <>
          <GlobalStyle />
          <App contentApiEndpoint={contentApiEndpoint} basepath={basepath} />
        </>
      </ThemeProvider>
    </Provider>,
    document.getElementById('configurator-root')
  );
};

if (
  'fetch' in window &&
  'Intl' in window &&
  'URL' in window &&
  'Map' in window &&
  'forEach' in NodeList.prototype &&
  'startsWith' in String.prototype &&
  'endsWith' in String.prototype &&
  'includes' in String.prototype &&
  'includes' in Array.prototype &&
  'assign' in Object &&
  'entries' in Object &&
  'keys' in Object
) {
  render();
} else {
  import('./polyfills').then(render);
}
